export default __webpack_public_path__ + "static/media/matic.ae70d51d.svg";